export default {"src":"/_next/static/image/public/images/ic_homecare_appointment.ccce063c101d3b32691d6fd7b5d9b9f6.gif","height":250,"width":250};